import { useMemo, useSyncExternalStore } from "react";
import { diagnosticChecklistStore as store } from "./diagnosticChecklistStore.ts";
import { DiagnosticChecklist } from "./diagnosticChecklistTypes.ts";

const PRIORITY_ORDER = ["term-info"];

// The ids in PRIORITY_ORDER come first. All other ids come after them.
// Array.prototype.sort is stable, so checklists with the same rank keep
// their registration order.
const priorityRank = ({ id }: DiagnosticChecklist) => {
  const index = PRIORITY_ORDER.indexOf(id);
  return index === -1 ? PRIORITY_ORDER.length : index;
};

export default function useDiagnosticChecklists(): DiagnosticChecklist[] {
  const checklists = useSyncExternalStore(store.subscribe, store.getSnapshot);
  return useMemo(
    () => [...checklists].sort((a, b) => priorityRank(a) - priorityRank(b)),
    [checklists]
  );
}
